import { render } from "./ListaDebitoVeicular.vue?vue&type=template&id=0b5e4dd8"
import script from "./ListaDebitoVeicular.vue?vue&type=script&lang=js"
export * from "./ListaDebitoVeicular.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__